/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindFileQueryResponse } from './FindFileQueryResponse';
import {
    FindFileQueryResponseFromJSON,
    FindFileQueryResponseFromJSONTyped,
    FindFileQueryResponseToJSON,
} from './FindFileQueryResponse';

/**
 * 
 * @export
 * @interface PublicFindOrganizationQueryResponse
 */
export interface PublicFindOrganizationQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicFindOrganizationQueryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicFindOrganizationQueryResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PublicFindOrganizationQueryResponse
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof PublicFindOrganizationQueryResponse
     */
    terms: string;
    /**
     * 
     * @type {FindFileQueryResponse}
     * @memberof PublicFindOrganizationQueryResponse
     */
    logo?: FindFileQueryResponse;
}

/**
 * Check if a given object implements the PublicFindOrganizationQueryResponse interface.
 */
export function instanceOfPublicFindOrganizationQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "terms" in value;

    return isInstance;
}

export function PublicFindOrganizationQueryResponseFromJSON(json: any): PublicFindOrganizationQueryResponse {
    return PublicFindOrganizationQueryResponseFromJSONTyped(json, false);
}

export function PublicFindOrganizationQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicFindOrganizationQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'domain': json['domain'],
        'terms': json['terms'],
        'logo': !exists(json, 'logo') ? undefined : FindFileQueryResponseFromJSON(json['logo']),
    };
}

export function PublicFindOrganizationQueryResponseToJSON(value?: PublicFindOrganizationQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'domain': value.domain,
        'terms': value.terms,
        'logo': FindFileQueryResponseToJSON(value.logo),
    };
}

